import { RootState } from "../../../redux-store";

export const selectIsOpen = (state: RootState) =>
  state.app.equipmentDialog.open;

export const selectInitialFormData = (state: RootState) =>
  state.app.equipmentDialog.initialFormData;
